import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

const TeacherDashboard = () => {
    const { t } = useTranslation();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await api.get('/teacher/dashboard/stats');
            if (response.data.success) {
                setStats(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching stats:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>{t('common.loading')}</p>
            </div>
        );
    }

    return (
        <div className="dashboard fade-in">
            <div className="page-header">
                <h1>{t('teacher.dashboard.title')}</h1>
            </div>

            <div className="stats-grid">
                <div className="stats-card">
                    <div className="content">
                        <h3>{stats?.courses || 0}</h3>
                        <p>{t('teacher.dashboard.myCourses')}</p>
                    </div>
                    <div className="icon-box purple">
                        <span className="material-icons">menu_book</span>
                    </div>
                </div>

                <div className="stats-card">
                    <div className="content">
                        <h3>{stats?.students || 0}</h3>
                        <p>{t('teacher.dashboard.myStudents')}</p>
                    </div>
                    <div className="icon-box green">
                        <span className="material-icons">people</span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TeacherDashboard;
